
const other = {}

other['AddFrame'] = '/icons/addFrame.svg'
other['Bunker'] = '/icons/bunker.svg'
other['Course'] = '/icons/course.svg'
other['Cuts'] = '/icons/cuts.svg'
other['Draghandle'] = '/icons/drag-handle.svg'
other['EditFrame'] = '/icons/editFrame.svg'
other['Eye'] = '/icons/eye.svg'
other['Fairway'] = '/icons/fairway.svg'
other['Focus'] = '/icons/focus.svg'
other['FocusFrame'] = '/icons/focusFrame.svg'
other['Game'] = '/icons/game.svg'
other['Grassbunker'] = '/icons/grassbunker.svg'
other['Green'] = '/icons/green.svg'
other['Hazards'] = '/icons/hazards.svg'
other['Hide'] = '/icons/hide.svg'
other['Map'] = '/icons/map.svg'
other['Mountain'] = '/icons/mountain.svg'
other['Other'] = '/icons/other.svg'
other['Path'] = '/icons/path.svg'
other['Road'] = '/icons/road.svg'
other['Rough'] = '/icons/rough.svg'
other['Save'] = '/icons/save.svg'
other['Tree'] = '/icons/tree.svg'
other['Forest'] = '/icons/forest.svg'
other['Stream'] = '/icons/stream.svg'
other['Tee'] = '/icons/tee.svg'
other['Teepoint'] = '/icons/teepoint.svg'
other['Trash'] = '/icons/trash.svg'
other['Triangle'] = '/icons/triangle.svg'
other['Unlock'] = '/icons/unlock.svg'
other['Vegetation'] = '/icons/vegetation.svg'
other['Wastearea'] = '/icons/wastearea.svg'
other['Sand'] = '/icons/sand.svg'
other['Water'] = '/icons/water.svg'
other['Ruler'] = '/icons/Ruler.svg'
other['Close'] = '/icons/Close.svg'
other['Help'] = '/icons/Help.svg'
other['Export'] = '/icons/Export.svg'
other['ArrowUp'] = '/icons/arrowUp.svg'
other['GoogleMapsLogo'] = '/icons/GoogleMapsLogo.svg'
other['BingMapsLogo'] = '/icons/BingMapsLogo.svg'
other['AzureMapsLogo'] = '/icons/AzureMapsLogo.svg'
other['Union'] = '/icons/Union.svg'
other['ArrowUpTail'] = "/icons/ArrowUpTail.svg"
other['DirectionalCircle'] = "/icons/DirectionalCircle.svg"
other['DirectionalChevron'] = "/icons/DirectionalChevron.svg"
other['DirectionalChevronRounded'] = "/icons/DirectionalChevronRounded.svg"
other['DropdownChevronDown'] = "/icons/DropdownChevronDown.svg"
other['FrameDirectionArrow'] = '/icons/FrameDirectionArrow.svg'
other['Simplify'] = '/icons/Simplify.svg'
other['Thicket'] = '/icons/Thicket.svg'
other['Inclination'] = '/icons/inclination.svg'
other['Line'] = '/icons/line.svg'
other['Measurements'] = '/icons/measurement.svg'
other['Import'] = '/icons/Import.svg'
other['EditGreen'] = '/icons/EditGreen.svg'
other['Text'] = '/icons/text.svg'
other['Playline'] = '/icons/playline.svg'
other['Reset'] = '/icons/Reset.svg'
other['Stonewall'] = '/icons/stonewall.svg'
other['Gravel'] = '/icons/gravel.svg'
other['Asphalt'] = '/icons/asphalt.svg'
other['RemoveOverlapping'] = '/icons/RemoveOverlapping.svg'
other['Railway'] = '/icons/Railway.svg'
other['Bridge'] = '/icons/bridge.svg'
other['Semigreen'] = '/icons/semigreen.svg'
other['Building'] = '/icons/building.svg'
other['BuildingSlanted'] = '/icons/buildingslanted.svg'
other['Settings'] = '/icons/settings.svg'
other['GreenFocus'] = '/icons/greenfocus.svg'
other['PenaltyArea'] = '/icons/penaltyarea.svg'
other['PuttingGreen'] = '/icons/puttinggreen.svg'
other['Filter'] = '/icons/filter.svg'
other['Bushes'] = '/icons/bushes.svg'
other['BushArea'] = '/icons/busharea.svg'
other['Loops'] = '/icons/Loop.svg'
other['RangeTee'] = '/icons/rangetee.svg'
other['Render'] = '/icons/render.svg'
other['TidyRotation'] = '/icons/tidyrotation.svg'
other['IconCollection'] = '/icons/iconcollection.svg'

const noMaskIcons = {}
noMaskIcons["ArrowDown"] = "/icons/ArrowDown.svg"
noMaskIcons['GreenBack'] = '/icons/GreenBack.svg'
noMaskIcons['GreenCenter'] = '/icons/GreenCenter.svg'
noMaskIcons['GreenFront'] = '/icons/GreenFront.svg'
noMaskIcons['TeeBlack'] = '/icons/TeeBlack.svg'
noMaskIcons['TeeBlue'] = '/icons/TeeBlue.svg'
noMaskIcons['TeeGreenWhite'] = '/icons/TeeGreenWhite.svg'
noMaskIcons['TeeOrange'] = '/icons/TeeOrange.svg'
noMaskIcons['TeeRed'] = '/icons/TeeRed.svg'
noMaskIcons['TeeWhite'] = '/icons/TeeWhite.svg'
noMaskIcons['TeeYellow'] = '/icons/TeeYellow.svg'
noMaskIcons['TeeYellowBlack'] = '/icons/TeeYellowBlack.svg'


export const renderIcons = {}
renderIcons["Bell"] = "/icons/render/Bell.svg"
renderIcons["Cart"] = "/icons/render/Cart.svg"
renderIcons["CartGarage"] = "/icons/render/CartGarage.svg"
renderIcons["ClubHouse"] = "/icons/render/ClubHouse.svg"
renderIcons["DropZone"] = "/icons/render/DropZone.svg"
renderIcons["EVCharging"] = "/icons/render/EVCharging.svg"
renderIcons["Defibrillator"] = "/icons/render/Defibrillator.svg"
renderIcons["Kiosk"] = "/icons/render/Kiosk.svg"
renderIcons["LightningShelter"] = "/icons/render/LightningShelter.svg"
renderIcons["NextTee"] = "/icons/render/NextTee.svg"
renderIcons["NoAccess"] = "/icons/render/NoAccess.svg"
renderIcons["NoCarts"] = "/icons/render/NoCarts.svg"
renderIcons["Parking"] = "/icons/render/Parking.svg"
renderIcons["Padel"] = "/icons/render/Padel.svg"
renderIcons["Pro"] = "/icons/render/Pro.svg"
renderIcons["Restaurant"] = "/icons/render/Restaurant.svg"
renderIcons["Shop"] = "/icons/render/Shop.svg"
renderIcons["Simulator"] = "/icons/render/Simulator.svg"
renderIcons["Warning"] = "/icons/render/Warning.svg"
renderIcons["WaterTap"] = "/icons/render/WaterTap.svg"
renderIcons["WC"] = "/icons/render/WC.svg"

const icons = { ...other, ...renderIcons, ...noMaskIcons }

function useMask(name) {
	let use = noMaskIcons[name] === undefined && renderIcons[name] === undefined
	return use
}
export function getDirectionalIconList() {
	return ['DirectionalCircle', 'DirectionalChevron', 'DirectionalChevronRounded']
}
export function getIconUrl(name) {
	return icons[name]
}
export function getIconHtml(name, classes, width, height) {
	if (!name) {
		return ''
	}
	let mw = "20px"
	if (classes === undefined) {
		classes = ''
	}
	if (width === undefined) {
		width = 'auto'
	} else {
		width = width + 'px'
		mw = width
	}
	if (height === undefined) {
		height = '20px'
	} else {
		height = height + 'px'
	}
	if (useMask(name) === true) {
		return `<div style='height: ${height}; width: ${width}; min-width: ${mw}; mask-image: url(${getIconUrl(name)})' class="svg-mask ${classes}"></div>`
	}
	return `<div style='height: ${height}; width: ${width}; min-width: ${mw}; background-image: url(${getIconUrl(name)})' class="svg-background ${classes}"></div>`
}
